import React from 'react';
import styled from 'styled-components';
import "@fontsource/ibm-plex-mono";


const Container = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  max-width: 1120px;
  padding: 22px;
  position: relative;
`;

const TextBlock = styled.div`
  flex: 1;

  @media (min-width: 1024px) {
    width: 350px;
  }
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 700;
  color: #a34117;
  margin-bottom: 20px;
`;

const Text = styled.p`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-indent: 50px;
  text-align: justify;
`;

const Image = styled.div`
  width: 270px;
  height: 450px;
  background-image: url('/media/about_photo.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 16px;
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }  
`;

const AboutPublisher: React.FC = () => (
  <Container>
    <TextBlock>
            <Title>ПРО ВИДАВНИЦТВО</Title>
            <Text>Видавництво «Сітон» — працює на видавничому ринку з 2011 року, видає навчальну літературу та довідники, виконує професійні високоякісні переклади українською мовою іноземної літератури, не тільки художньої, але й складного фінансово-економічного, науково-технічного напряму.</Text>
            <Text>Співпрацювало з видавництвами світового рівня, такими як Pearson, Pinguin Books, Dorling Kindersley. З початком війни «Сітон» приєднав до себе видавництво «Райдуга» і почав активно видавати твори сучасних українських письменників. Деякі з нових книжок видавництва зараз перекладаються і готуються до видання у Великобританії, Німеччині, Фінляндії.</Text>
    </TextBlock>
    <Image style={{ backgroundImage: "/media/about_photo.jpg" }} />
  </Container>
);

export default AboutPublisher;
